import React from "react";

export const Plus = {
  viewBox: "0 0 512 512",
  body: () => (
    <path d="M496 192h-176v-176c0-8.836-7.164-16-16-16h-96c-8.836 0-16 7.164-16 16v176h-176c-8.836 0-16 7.164-16 16v96c0 8.836 7.164 16 16 16h176v176c0 8.836 7.164 16 16 16h96c8.836 0 16-7.164 16-16v-176h176c8.836 0 16-7.164 16-16v-96c0-8.836-7.164-16-16-16z" />
  )
};

export const Minus = {
  viewBox: "0 0 512 512",
  body: () => (
    <path d="M0 208v96c0 8.836 7.164 16 16 16h480c8.836 0 16-7.164 16-16v-96c0-8.836-7.164-16-16-16h-480c-8.836 0-16 7.164-16 16z" />
  )
};

export const Tick = {
  viewBox: "0 0 512 512",
  body: () => <path d="M432 64l-240 240-112-112-80 80 192 192 320-320z" />
};

export const Spinner = {
  viewBox: "0 0 30 30",
  body: () => (
    <g fill="none" fillRule="evenodd" strokeWidth="3">
      <circle cx="15" cy="15" r="13.5" stroke="#898989" opacity=".1" />
      <path
        stroke="#28283c"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M28.5 15c0-7.456-6.044-13.5-13.5-13.5"
      />
    </g>
  )
};

export const HeartFull = {
  viewBox: "0 0 24 24",
  body: () => (
    <g
      id="icon/favourite_selected"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M12.0205751,21.9874864 C12.1389048,21.8813568 12.275561,21.7586198 12.4487813,21.6029551 C12.4785884,21.5761687 12.4785884,21.5761687 12.5084022,21.5493763 C13.4686231,20.6864686 13.9204424,20.2844145 14.4771861,19.8029466 C15.1145894,19.2515463 15.6558189,18.7898899 16.7651884,17.8483649 C16.8189256,17.8027583 16.8189256,17.8027583 16.8726547,17.7571588 C17.7845449,16.9832393 18.2261424,16.6071887 18.7476792,16.1588173 C19.8476734,15.2129984 20.6401125,14.4457039 21.3218329,13.6308751 C22.0767466,12.7269538 22.6068253,11.7893421 22.9144676,10.7813317 C23.1177036,10.1139794 23.2410206,9.40727928 23.2912442,8.65232799 C23.3510403,7.74734989 23.3462293,7.19573515 23.2476906,6.64432803 C23.0372265,5.47028323 22.5147106,4.49735649 21.6603839,3.71070754 C20.7425766,2.86483281 19.6361545,2.39840656 18.3243841,2.29417996 C17.4715867,2.22618864 16.6592104,2.33797871 15.8815033,2.63294967 C14.7826969,3.04925149 13.8688756,3.75413061 13.104612,4.75013309 C13.0426631,4.8310636 12.9797121,4.91828354 12.8966494,5.03727863 C12.9028378,5.02841311 12.7110623,5.30505155 12.6525029,5.3877529 L12.0172533,6.28489397 L11.4136092,5.36618947 C11.3862245,5.32535738 11.3862245,5.32535738 11.3457498,5.26374113 C11.3419652,5.2577797 11.3419652,5.2577797 11.3410284,5.25626306 C11.021803,4.7540506 10.6895031,4.33810427 10.3200682,3.98945047 C8.5595109,2.32894634 6.58462655,1.85408108 4.32402799,2.57862086 C2.25317987,3.2419462 0.858005774,5.09528123 0.760458404,7.31239819 C0.728612093,8.03689314 0.76965777,8.77469827 0.881256456,9.5225607 C1.02093975,10.4573923 1.29044736,11.3067225 1.70277811,12.0826032 C2.15381895,12.9319388 2.77675193,13.7265179 3.63548893,14.5924476 C4.44974805,15.4123006 5.15225307,16.0343297 6.75705699,17.3949701 C6.76399615,17.4008535 6.76399615,17.4008535 6.7709359,17.4067374 C6.84451498,17.4691221 6.84451498,17.4691221 6.91820796,17.5316192 C9.34420953,19.5897158 10.6324191,20.7072976 12.0205751,21.9874864 Z"
        id="Stroke-7"
        stroke="#FADCDC"
        strokeWidth="1.5"
        fill="#822D50"
      />
    </g>
  )
};

export const Heart = {
  viewBox: "0 0 24 24",
  body: () => (
    <g
      id="icon/favourite_incative"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M11.9806629,21.9160537 C12.0982105,21.8106239 12.2339359,21.6887225 12.4057578,21.5343145 C12.4354658,21.5076172 12.4354658,21.5076172 12.4651806,21.4809137 C13.4222229,20.6208625 13.8725493,20.2201368 14.427459,19.740255 C15.0627525,19.1906799 15.6021881,18.7305536 16.7078778,17.7921517 C16.7614365,17.7466966 16.7614365,17.7466966 16.8149871,17.7012486 C17.7238438,16.9299036 18.1639714,16.5551047 18.68377,16.1082276 C19.7800153,15.1656321 20.5697319,14.4009737 21.2490838,13.588976 C22.001285,12.6883025 22.5294386,11.7540962 22.8359562,10.7497708 C23.0384593,10.0848249 23.1613339,9.38066007 23.2113784,8.62840182 C23.2709635,7.72661697 23.26617,7.17700285 23.1680032,6.62767691 C22.9583329,5.45806041 22.4378168,4.48885742 21.5867339,3.70519522 C20.6723946,2.86251673 19.5701757,2.39786238 18.2633077,2.2940253 C17.4137071,2.22628885 16.6043992,2.33765667 15.8296236,2.63151579 C14.7349161,3.04626466 13.8245032,3.74851477 13.0630537,4.74084983 C13.0013366,4.82147752 12.9386142,4.90838066 12.8558465,5.02695307 C12.8620208,5.01810793 12.6708749,5.29383809 12.6125016,5.37627668 L11.9772519,6.27341775 L11.3736078,5.35471325 C11.3463368,5.31405108 11.3463368,5.31405108 11.3059544,5.2525751 C11.3021771,5.24662536 11.3021771,5.24662536 11.3012477,5.24512043 C10.9831874,4.74474085 10.6521185,4.33033547 10.2840726,3.98299252 C8.53001555,2.3286192 6.56263521,1.8555583 4.31042254,2.57741033 C2.24745443,3.23821158 0.857599003,5.08448135 0.760421255,7.29319732 C0.728687887,8.01512283 0.769588324,8.75031723 0.88079303,9.49553946 C1.0199717,10.4269938 1.28849802,11.2732316 1.69932168,12.0462764 C2.14873576,12.8925488 2.7694545,13.6843035 3.62517881,14.5471953 C4.43666601,15.3642573 5.13680144,15.9841882 6.73621967,17.3402624 C6.74313578,17.3461262 6.74313578,17.3461262 6.75005247,17.3519906 C6.82338717,17.414168 6.82338717,17.414168 6.8968358,17.476458 C9.31382771,19.5269112 10.5977164,20.6407257 11.9806629,21.9160537 Z"
        id="Stroke-7"
        stroke="#822D50"
        strokeWidth="1.5"
      />
    </g>
  )
};

export const ChevronLeft = {
  viewBox: "0 0 20 20",
  body: () => (
    <path
      fill="none"
      fillRule="evenodd"
      stroke="#565A5C"
      strokeLinecap="square"
      strokeWidth="2"
      d="M11.86 3L5 10l6.86 6.62"
    />
  )
};

export const ChevronPrev = {
  viewBox: "0 0 8 12",
  body: () => <path d="M7.41 1.41L6 0L0 6L6 12L7.41 10.59L2.83 6L7.41 1.41Z" />
};

export const ChevronNext = {
  viewBox: "0 0 8 12",
  body: () => (
    <path d="M0.59 10.59L2 12L8 6L2 -5.24537e-07L0.590001 1.41L5.17 6L0.59 10.59Z" />
  )
};

export const ChevronUp = {
  viewBox: "0 0 12 8",
  body: () => (
    <path d="M10.59 7.41L12 6L6 7.15493e-08L7.15493e-08 6L1.41 7.41L6 2.83L10.59 7.41Z" />
  )
};

export const ChevronDown = {
  viewBox: "0 0 12 8",
  body: () => (
    <path d="M 10.59,7.15493e-8 12,1.4100001 6,7.41 7.15493e-8,1.4100001 1.41,7.15493e-8 6,4.5800001 Z" />
  )
};

export const Play = {
  viewBox: "0 0 512 512",
  body: () => <path d="M96 64l320 192-320 192z" />
};

export const Cross = {
  viewBox: "0 0 20 20",
  body: () => (
    <g
      fill="none"
      fillRule="evenodd"
      stroke="#565A5C"
      strokeLinecap="square"
      strokeWidth="2"
    >
      <path d="M3 3l13.86 13.86M16.86 3L3 16.86" />
    </g>
  )
};

export const Search = {
  viewBox: "0 0 20 20",
  body: () => (
    <g
      fill="none"
      fillRule="evenodd"
      strokeWidth="2"
      transform="translate(1 1)"
    >
      <circle cx="7.5" fill="none" cy="7.5" r="7.5" />
      <path strokeLinecap="square" d="M13.5 13.5l4 4" />
    </g>
  )
};

export const BoldSearch = {
  viewBox: "0 0 16 15",
  body: () => (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.435 6.33279C10.435 5.22334 10.0407 4.27434 9.25211 3.48573C8.4635 2.69713 7.5145 2.30283 6.40505 2.30283C5.29561 2.30283 4.3466 2.69713 3.558 3.48573C2.76939 4.27434 2.3751 5.22334 2.3751 6.33279C2.3751 7.44223 2.76939 8.39124 3.558 9.17984C4.3466 9.96845 5.29561 10.3627 6.40505 10.3627C7.5145 10.3627 8.4635 9.96845 9.25211 9.17984C10.0407 8.39124 10.435 7.44223 10.435 6.33279ZM15.0407 13.817C15.0407 14.1288 14.9267 14.3987 14.6988 14.6266C14.471 14.8545 14.2011 14.9684 13.8893 14.9684C13.5654 14.9684 13.2956 14.8545 13.0797 14.6266L9.99423 11.5501C8.92077 12.2938 7.72439 12.6656 6.40505 12.6656C5.54748 12.6656 4.72741 12.4992 3.9448 12.1663C3.16219 11.8335 2.48754 11.3837 1.92083 10.817C1.35411 10.2503 0.904345 9.57565 0.571512 8.79304C0.23868 8.01043 0.0722656 7.19036 0.0722656 6.33279C0.0722656 5.47522 0.23868 4.65514 0.571512 3.87254C0.904345 3.08993 1.35411 2.41528 1.92083 1.84856C2.48754 1.28185 3.16219 0.83208 3.9448 0.499247C4.72741 0.166414 5.54748 0 6.40505 0C7.26262 0 8.0827 0.166414 8.8653 0.499247C9.64791 0.83208 10.3226 1.28185 10.8893 1.84856C11.456 2.41528 11.9058 3.08993 12.2386 3.87254C12.5714 4.65514 12.7378 5.47522 12.7378 6.33279C12.7378 7.65212 12.366 8.84851 11.6224 9.92197L14.7078 13.0074C14.9297 13.2293 15.0407 13.4992 15.0407 13.817Z"
      fill="black"
    />
  )
};

export const Menu = {
  viewBox: "0 0 28 20",
  body: () => (
    <g>
      <path d="M0 0h28v2H0zM0 9h28v2H0zM0 18h28v2H0z" />
    </g>
  )
};

export const Calendar = {
  viewBox: "0 0 20 20",
  body: () => (
    <g
      fill="none"
      fillRule="evenodd"
      stroke="#822D50"
      transform="translate(2 1)"
    >
      <rect width="15" height="14" x=".5" y="2.5" rx="2" />
      <path strokeLinecap="square" d="M1 7.5h14M11.5.5V4M4.5.5V4" />
    </g>
  )
};

export const ArrowForwards = {
  viewBox: "0 0 20 20",
  body: () => (
    <g fill="none" fillRule="evenodd" stroke="#822D50">
      <path strokeLinecap="square" d="M16 10.5H2" />
      <path d="M10.99 16.52L17 10.51 10.99 4.5" />
    </g>
  )
};

export const Location = {
  viewBox: "0 0 20 20",
  body: () => (
    <g fill="none" fillRule="evenodd">
      <g stroke="#C5C5C5" strokeLinecap="square" transform="translate(3.5 2.5)">
        <circle cx="6.516" cy="5.976" r="2.516" />
        <path d="M2.154 11.127A6.484 6.484 0 0 1 0 6.294C0 2.704 2.91 0 6.5 0S13 2.704 13 6.294c0 1.917-.829 3.64-2.148 4.83C8.988 13.32 6.5 14.91 6.5 14.91s-2.484-1.588-4.347-3.784z" />
      </g>
    </g>
  )
};

export const LocationBold = {
  viewBox: "0 0 17 22",
  body: () => (
    <path
      d="M8.32001 22C8.09289 21.897 7.9025 21.7308 7.77307 21.5226C5.66474 18.6296 3.54052 15.7476 1.44353 12.8458C0.64489 11.7322 0.161311 10.4351 0.0410045 9.08382C-0.313032 5.56383 1.65006 2.17803 4.97936 0.781037C8.21108 -0.57636 11.2635 -0.162761 13.9959 2.00864C14.8199 2.658 15.5034 3.45869 16.0074 4.36477C16.5113 5.27084 16.8258 6.26447 16.9326 7.28863C17.2042 9.34606 16.6483 11.4259 15.3803 13.0966C13.3393 15.8833 11.2968 18.6751 9.25276 21.472C9.11988 21.7011 8.91796 21.8853 8.67405 22H8.32001ZM11.3271 8.28082C11.3292 7.73932 11.1661 7.20928 10.8583 6.75739C10.5505 6.3055 10.1118 5.95192 9.59722 5.74115C9.08267 5.53037 8.5153 5.4718 7.9665 5.5728C7.41769 5.6738 6.91195 5.92987 6.51288 6.30879C6.11382 6.68772 5.83925 7.17257 5.72372 7.70238C5.60819 8.23218 5.65686 8.78327 5.86359 9.28633C6.07033 9.78939 6.42591 10.222 6.8856 10.5296C7.34529 10.8373 7.88857 11.0063 8.4471 11.0154C8.82159 11.0198 9.19329 10.9524 9.54088 10.8173C9.88847 10.6821 10.2051 10.4817 10.4727 10.2277C10.7402 9.97362 10.9534 9.67088 11.1 9.3368C11.2466 9.00272 11.3238 8.64387 11.3271 8.28082Z"
      fill="#28283C"
    />
  )
};

export const Star = {
  viewBox: "0 0 14 13",
  body: () => (
    <path
      d="M5.9251 0.972864C6.21518 0.255578 7.23073 0.255577 7.52081 0.972864L8.64561 3.75417C8.76889 4.05902 9.05511 4.26697 9.38314 4.29002L12.3759 4.50029C13.1477 4.55452 13.4615 5.52036 12.869 6.0179L10.5714 7.94712C10.3196 8.15857 10.2102 8.49504 10.2897 8.81414L11.0145 11.7254C11.2015 12.4762 10.3799 13.0731 9.72357 12.6633L7.17878 11.0743C6.89985 10.9002 6.54606 10.9002 6.26714 11.0743L3.72234 12.6633C3.06605 13.0731 2.24446 12.4762 2.43139 11.7254L3.15622 8.81414C3.23567 8.49505 3.12634 8.15857 2.87451 7.94712L0.576912 6.0179C-0.0156283 5.52036 0.298191 4.55452 1.07001 4.50029L4.06277 4.29002C4.3908 4.26697 4.67702 4.05902 4.80031 3.75417L5.9251 0.972864Z"
      fill="#00C040"
    />
  )
};

export const EmptyStar = {
  viewBox: "0 0 14 13",
  body: () => (
    <path
      d="M5.9251 0.972864C6.21518 0.255578 7.23073 0.255577 7.52081 0.972864L8.64561 3.75417C8.76889 4.05902 9.05511 4.26697 9.38314 4.29002L12.3759 4.50029C13.1477 4.55452 13.4615 5.52036 12.869 6.0179L10.5714 7.94712C10.3196 8.15857 10.2102 8.49504 10.2897 8.81414L11.0145 11.7254C11.2015 12.4762 10.3799 13.0731 9.72357 12.6633L7.17878 11.0743C6.89985 10.9002 6.54606 10.9002 6.26714 11.0743L3.72234 12.6633C3.06605 13.0731 2.24446 12.4762 2.43139 11.7254L3.15622 8.81414C3.23567 8.49505 3.12634 8.15857 2.87451 7.94712L0.576912 6.0179C-0.0156283 5.52036 0.298191 4.55452 1.07001 4.50029L4.06277 4.29002C4.3908 4.26697 4.67702 4.05902 4.80031 3.75417L5.9251 0.972864Z"
      fill="#f0f0f0"
    />
  )
};

export const HalfStar = {
  viewBox: "0 0 15 15",
  body: () => [
    <defs key="half-star-defs">
      <polygon
        id="path-1"
        points="7.5 11.82895 2.86474508 14.2658477 3.75 9.10441554 1.11022302e-16 5.44906896 5.18237254 4.69602615 7.5 0 9.81762746 4.69602615 15 5.44906896 11.25 9.10441554 12.1352549 14.2658477"
      />
    </defs>,
    <g
      key="half-star"
      id="Star_Half"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Rectangle">
        <mask id="mask-2" fill="white">
          <use xlinkHref="#path-1" />
        </mask>
        <use id="Mask" fill="#822D50" xlinkHref="#path-1" />
        <rect
          fill="#F0F0F0"
          mask="url(#mask-2)"
          x="7.5"
          y="0"
          width="8"
          height="15"
        />
      </g>
    </g>
  ]
};

export const BarChart = {
  viewBox: "0 0 20 20",
  body: () => (
    <g fill="none" fillRule="evenodd">
      <path
        stroke="#C5C5C5"
        d="M12.5 17.5h5V4A1.5 1.5 0 0 0 16 2.5h-2A1.5 1.5 0 0 0 12.5 4v13.5zM2.5 17.5h5V13A1.5 1.5 0 0 0 6 11.5H4A1.5 1.5 0 0 0 2.5 13v4.5zM7.5 17.5h5V8A1.5 1.5 0 0 0 11 6.5H9A1.5 1.5 0 0 0 7.5 8v9.5z"
      />
    </g>
  )
};

export const Clock = {
  viewBox: "0 0 20 20",
  body: () => (
    <g fill="none" fillRule="evenodd">
      <g stroke="#C5C5C5" transform="translate(2 2)">
        <circle cx="8" cy="8" r="7.5" />
        <path strokeLinecap="square" d="M12.968 8H8V3.04" />
      </g>
    </g>
  )
};

export const Ball = {
  viewBox: "0 0 35 35",
  body: () => (
    <path
      d="M34.5 17.5C34.5 26.8888 26.8888 34.5 17.5 34.5C8.11116 34.5 0.5 26.8888 0.5 17.5C0.5 8.11116 8.11116 0.5 17.5 0.5C26.8888 0.5 34.5 8.11116 34.5 17.5Z"
      fill="#00D2C8"
      stroke="#00D2C8"
    />
  )
};
export const Envelope = {
  viewBox: "0 0 20 16",
  body: () => (
    <path d="M18 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM18 4L10 9L2 4V2L10 7L18 2V4Z" />
  )
};

export const Clock12h20m = {
  viewBox: "0 0 20 20",
  body: () => [
    <path
      key={0}
      d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z"
    />,
    <path key={1} d="M10.5 5H9V11L14.25 14.15L15 12.92L10.5 10.25V5Z" />
  ]
};

export const PoundSymbol = {
  viewBox: "0 0 12 18",
  body: () => (
    <path d="M0.5 17.25V15.4167C4.16667 13.5833 3.70833 9.91667 3.70833 9.91667H1.41667V8.08333H3.70833C2.79167 3.95833 4.16667 0.75 7.83333 0.75C9.66667 0.75 10.5833 1.20833 10.5833 1.20833V3.04167C5.08333 1.20833 5.08333 5.33333 5.54167 8.08333H9.66667V9.91667H5.54167C5.54167 9.91667 6 13.5833 3.70833 15.4167H11.5V17.25H0.5Z" />
  )
};
export const User = {
  viewBox: "0 0 40 40",
  body: () => [
    <defs key="user-defs">
      <circle id="a" cx="20" cy="20" r="20" />
    </defs>,
    <g fill="none" fillRule="evenodd" key="user-g">
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <use fill="#FAAA1E" xlinkHref="#a" />
      <g fillRule="nonzero" mask="url(#b)">
        <ellipse cx="19.972" cy="19.87" fill="#FAAA1E" rx="19.972" ry="19.87" />
        <path
          fill="#28283C"
          d="M20.028 27.353c-1.098 0-2.169-.449-3.127-1.177v1.205c0 2.186 6.761 2.102 6.761-.477v-.924c-1.127.868-2.366 1.373-3.634 1.373z"
          opacity=".5"
        />
        <g fill="#28283C">
          <path d="M23.972 28.054V26.12c.986-.785 1.915-1.878 2.648-3.14.253 1.234.901 2.075 1.662 2.075 1.014 0 1.803-1.458 1.803-3.307 0-.925-.198-1.71-.508-2.326.029-.056.085-.112.113-.168.62-1.037 1.042-3.167.817-4.12-.14-.589-.592-1.233-1.24-1.29-.225-.027-.478.029-.732.225.085-.897.085-1.822.057-2.747-.085-1.681-.226-3.503-1.127-4.96-1.296-2.074-4.564-3.083-6-.729-2.395-2.046-5.944-1.485-7.493 1.29-1.578-1.066-4.31-1.57-4.986.784-.507 1.794.986 2.83 2.45 3.56.198.644.451 1.709.677 2.718.028.112.028.224.056.336 0 .112-.028.224-.028.336a1.313 1.313 0 0 0-.733-.056c-.422.084-.732.393-.873.841-.253.869.17 2.466.733 3.447-.536.56-.874 1.626-.874 2.859 0 1.85.79 3.307 1.803 3.307.789 0 1.437-.897 1.69-2.158.76 1.457 1.719 2.634 2.79 3.447v1.597c-2.592 1.065-4.846 3.391-6.62 6.895-2.029 4.007-2.761 8.24-2.761 8.267l.591.112c.028-.14 2.057-11.63 8.817-14.629a3.672 3.672 0 0 0 3.634 3.195 3.637 3.637 0 0 0 3.606-3.11c7.408 3.222 7.493 15.077 7.493 15.217h.591c0-.14-.113-12.584-8.056-15.834zm4.31-3.588c-.536 0-1.099-.953-1.183-2.382.338-.7.647-1.457.873-2.242.31.168.676.168.986.084.056-.028.112-.028.197-.084a4.94 4.94 0 0 1 .366 1.878c-.056 1.625-.676 2.746-1.24 2.746zm-16.113 0c-.563 0-1.211-1.12-1.211-2.718 0-1.065.281-1.878.62-2.354.225.252.422.42.647.476.141.028.282.056.423.056.197.7.422 1.345.704 1.962-.028 1.513-.62 2.578-1.183 2.578zm11.183 3.672c0 1.681-1.38 3.026-3.042 3.026a3.04 3.04 0 0 1-3.042-3.026v-1.374c.873.56 1.83.87 2.76.87h.028c1.127 0 2.254-.393 3.296-1.094v1.598zm-3.296-1.093c-2.845-.028-5.718-3.195-6.901-7.567-.028-.084-.085-.168-.17-.196-.027-.028-.084-.028-.112-.028-.056 0-.084 0-.14.028-.057.056-.17.056-.339 0-.056-.028-.281-.113-.62-.645-.563-.953-.873-2.41-.704-3.027a.541.541 0 0 1 .423-.42c.225-.056.507.028.648.224a.455.455 0 0 0 .197.112c.254 1.485.592 2.97.76 3.083l.085.028.056-.028c.057-.028.085-.112.085-.477-.056-1.681.338-5.016 1.55-6.361 1.154-.168 2.28-.477 3.295-1.01-.282.281-.592.561-.901.785-.282.169-.17.617.169.617 1.83.028 3.549-.7 5.183-1.485-.395.392-.817.728-1.38.953-.31.112-.339.532 0 .644 1.52.533 2.985.308 4.366-.448a15.11 15.11 0 0 1 1.52 5.633c.029.392.536.448.677.084.253-.757.45-1.513.563-2.27.028-.028.057-.056.085-.112.225-.477.479-.729.732-.729.282.028.62.392.732.84.198.814-.197 2.747-.732 3.644-.197.337-.338.393-.394.393-.507.112-.62-.085-.704-.197a.3.3 0 0 0-.226-.168.3.3 0 0 0-.225.028c-.057.028-.113.112-.141.168-1.127 4.54-4.31 7.904-7.437 7.904z" />
          <path d="M19.634 20.991a.312.312 0 0 0-.31-.308c-.197 0-.282-.084-.31-.168-.113-.225 0-.617.197-.87.113-.111.085-.307-.028-.42-.113-.112-.31-.084-.422.029-.367.42-.48 1.064-.282 1.513.14.336.45.504.845.504.169.028.31-.112.31-.28zM22.76 16.367a.575.575 0 0 0-.591.588.575.575 0 0 0 .592.589.575.575 0 0 0 .591-.589.575.575 0 0 0-.592-.589zM16.648 16.563a.575.575 0 0 0-.592.589.575.575 0 0 0 .592.589.593.593 0 0 0 .422-1.01c-.112-.112-.253-.14-.422-.168zM18.14 14.966c-1.267-.533-2.196-.14-2.929.308-.14.084-.197.28-.084.42.056.084.14.14.253.14a.402.402 0 0 0 .17-.056c.253-.168.506-.28.732-.364l.957-.112c.226.028.451.084.676.196.141.056.339 0 .395-.168.028-.14-.028-.308-.17-.364zM24.732 16.199c.057 0 .141-.028.198-.056.14-.112.14-.28.056-.42-.873-1.066-1.887-1.15-2.732-1.094-.17 0-.282.14-.282.309 0 .168.169.28.31.28.31-.028.563 0 .817.028l.901.364c.169.14.366.28.507.477.056.056.14.112.225.112zM23.014 22.869c-.14-.056-.338 0-.394.168-.48 1.149-2.338 1.149-3.127.98a.314.314 0 0 0-.366.225c-.028.168.056.308.225.364.282.056.62.112.986.112 1.099 0 2.338-.336 2.817-1.429.084-.196 0-.364-.14-.42z" />
        </g>
      </g>
    </g>
  ]
};

export const Bin = {
  viewBox: "0 0 23 29",
  body: () => [
    <path
      key={1}
      d="M5.75 8.23584V21.0422H17.25V8.23584H15.87V19.6502H7.13V8.23584H5.75Z"
      fill="black"
    />,
    <path
      key={2}
      d="M3.54102 6.00891H19.457V4.61691H14.558V2.15771H8.44002V4.61691H3.54102V6.00891ZM9.82002 3.54971H13.178V4.61691H9.82002V3.54971Z"
      fill="black"
    />,
    <path
      key={3}
      d="M10.3488 8.23584H8.96875V17.5738H10.3488V8.23584Z"
      fill="black"
    />,
    <path
      key={4}
      d="M14.0284 8.23584H12.6484V17.5738H14.0284V8.23584Z"
      fill="black"
    />
  ]
};

export const TealTick = {
  viewBox: "0 0 35 35",
  body: () => [
    <g key="teal-tick-g" fill="none" fillRule="evenodd">
      <circle cx="17.5" cy="17.5" r="17" fill="#00D2C8" stroke="#00D2C8" />
      <path stroke="#FFF" strokeWidth="3" d="M10 18.019L14.835 22 25 11" />
    </g>
  ]
};

export const NarrowTick = {
  viewBox: "0 0 14 14",
  body: () => [
    <path
      key={"narrow-tick"}
      d="M 5,12.21 0,7.2099999 1.41,5.7999999 5,9.38 l 7.59,-7.5900001 1.41,1.42 z"
    />
  ]
};

export const FilledCircleTick = {
  viewBox: "0 0 35 35",
  body: () => [
    <g key="teal-tick-g" fill="none" fillRule="evenodd">
      <circle cx="17.5" cy="17.5" r="17" fill="#32c864" stroke="#32c864" />
      <path stroke="#FFF" strokeWidth="3" d="M10 18.019L14.835 22 25 11" />
    </g>
  ]
};

export const Cancel = {
  viewBox: "0 0 20 20",
  body: () => [
    <path
      key="cancel-path"
      d="M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM15 13.59L13.59 15L10 11.41L6.41 15L5 13.59L8.59 10L5 6.41L6.41 5L10 8.59L13.59 5L15 6.41L11.41 10L15 13.59Z"
      fill="#822D50"
    />
  ]
};

export const Copy = {
  viewBox: "0 0 640 640",
  body: () => (
    <path
      fill="#000"
      d="M192 192v-128c0-35.2 28.8-64 64-64h320c35.346 0 64 28.654 64 64v0 320c0 35.346-28.654 64-64 64v0h-128v128c0 35.346-28.654 64-64 64v0h-320c-35.346 0-64-28.654-64-64v0-320c0-35.2 28.8-64 64-64h128zM256 192h128c35.346 0 64 28.654 64 64v0 128h128v-320h-320v128zM64 256v320h320v-320h-320z"
    />
  )
};

export const CricleCross = {
  viewBox: "0 0 20 20",
  body: () => (
    <path
      d="M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM15 13.59L13.59 15L10 11.41L6.41 15L5 13.59L8.59 10L5 6.41L6.41 5L10 8.59L13.59 5L15 6.41L11.41 10L15 13.59Z"
      fill="#FBB231"
    />
  )
};

export const Wait = {
  viewBox: "0 0 20 20",
  body: () => [
    <path
      key="wait-path"
      d="M19.5 10C19.5 15.2467 15.2467 19.5 10 19.5C4.75329 19.5 0.5 15.2467 0.5 10C0.5 4.7533 4.7533 0.5 10 0.5C15.2467 0.5 19.5 4.75329 19.5 10Z"
      fill="#822D50"
      stroke="#822D50"
    />,
    <g key="wait-g" clipPath="url(#clip0)">
      <path
        d="M14.6264 7.35632L11.9827 10H13.9655C13.9655 12.1876 12.1876 13.9655 9.99997 13.9655C9.33244 13.9655 8.69796 13.8003 8.1494 13.5029L7.18446 14.4678C7.99739 14.9833 8.96233 15.2874 9.99997 15.2874C12.9212 15.2874 15.2873 12.9213 15.2873 10H17.2701L14.6264 7.35632ZM6.03446 10C6.03446 7.81236 7.81233 6.03449 9.99997 6.03449C10.6675 6.03449 11.302 6.19972 11.8505 6.49713L12.8155 5.53219C12.0026 5.01667 11.0376 4.71265 9.99997 4.71265C7.07871 4.71265 4.71262 7.07874 4.71262 10H2.72986L5.37354 12.6437L8.01721 10H6.03446Z"
        fill="white"
      />
    </g>,
    <defs key="wait-defs">
      <clipPath id="clip0">
        <rect
          width="15.8621"
          height="15.8621"
          fill="white"
          transform="translate(2.06897 2.06885)"
        />
      </clipPath>
    </defs>
  ]
};

export const Guest = {
  viewBox: "0 0 20 20",
  body: () => [
    <path
      key="guest-path"
      d="M13.5 6C13.5 7.933 11.933 9.5 10 9.5C8.067 9.5 6.5 7.933 6.5 6C6.5 4.067 8.067 2.5 10 2.5C11.933 2.5 13.5 4.067 13.5 6Z"
      stroke="#d8d8d8"
      strokeLinecap="square"
      fill="white"
    />,
    <path
      key="guest-path-2"
      d="M17.4353 17.5H2.50218C2.51935 17.357 2.54419 17.1883 2.5801 16.9999C2.69799 16.3813 2.93298 15.5624 3.39853 14.7482C4.31092 13.1525 6.14732 11.5 9.96875 11.5C13.7902 11.5 15.6266 13.1525 16.539 14.7482C17.0045 15.5624 17.2395 16.3813 17.3574 16.9999C17.3933 17.1883 17.4181 17.357 17.4353 17.5Z"
      stroke="#d8d8d8"
      strokeLinecap="square"
      fill="white"
    />,
    <rect key="guest-rect" width="20" height="20" fillOpacity="0" />
  ]
};

export const Bell = {
  viewBox: "0 0 16 20",
  body: () => [
    <mask key="bell-mask" id="path-1-inside-1" fill="white">
      <path
        key="bell-mask-path"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1.85742C11.1559 1.85742 13.7143 4.41579 13.7143 7.57171L13.7143 14.4289L16 16.7146H0L2.28571 14.4289V7.57171C2.28571 4.41579 4.84409 1.85742 8 1.85742Z"
      />
    </mask>,
    <path
      key="bell-path-1"
      d="M13.7143 7.57171H12.5714H12.5714H13.7143ZM13.7143 14.4289H12.5714V14.9022L12.9062 15.237L13.7143 14.4289ZM16 16.7146V17.8574H18.7591L16.8081 15.9064L16 16.7146ZM0 16.7146L-0.808122 15.9064L-2.7591 17.8574H0V16.7146ZM2.28571 14.4289L3.09384 15.237L3.42857 14.9022V14.4289H2.28571ZM14.8571 7.57171C14.8571 3.78461 11.7871 0.714565 8 0.714565V3.00028C10.5247 3.00028 12.5714 5.04698 12.5714 7.57171H14.8571ZM14.8571 14.4289L14.8571 7.57171H12.5714L12.5714 14.4289H14.8571ZM12.9062 15.237L15.1919 17.5227L16.8081 15.9064L14.5224 13.6207L12.9062 15.237ZM16 15.5717H0V17.8574H16V15.5717ZM0.808122 17.5227L3.09384 15.237L1.47759 13.6207L-0.808122 15.9064L0.808122 17.5227ZM1.14286 7.57171V14.4289H3.42857V7.57171H1.14286ZM8 0.714565C4.2129 0.714565 1.14286 3.78461 1.14286 7.57171H3.42857C3.42857 5.04698 5.47527 3.00028 8 3.00028V0.714565Z"
      fill="#929292"
      mask="url(#path-1-inside-1)"
    />,
    <path
      key="bell-path-2"
      d="M10.2858 16.7148C10.2858 17.9772 9.26244 19.0006 8.00007 19.0006C6.7377 19.0006 5.71436 17.9772 5.71436 16.7148"
      stroke="#929292"
      strokeWidth="1.14286"
      strokeLinecap="square"
    />,
    <line
      key="bell-line"
      x1="7.99986"
      y1="2.42906"
      x2="7.99986"
      y2="1.2862"
      stroke="#929292"
      strokeWidth="1.14286"
      strokeLinecap="square"
    />
  ]
};

export const HeartInCircleFull = {
  viewBox: "0 0 24 24",
  body: () => [
    <circle key={1} cx="12" cy="12" r="12" fill="#CDD2D2" />,
    <path
      key={2}
      d="M17.993 11.0238C18 10.9377 18 10.889 18 10.889C18 10.1228 17.6839 9.38795 17.1213 8.84616C16.5587 8.30437 15.7957 8 15 8C14.2044 8 13.4413 8.30437 12.8787 8.84616C12.3161 9.38795 12 10.1228 12 10.889C12 10.1228 11.6839 9.38795 11.1213 8.84616C10.5587 8.30437 9.79565 8 9 8C8.20435 8 7.44129 8.30437 6.87868 8.84616C6.31607 9.38795 6 10.1228 6 10.889C6 10.889 6 10.9384 6.00701 11.0238C6.01736 11.2607 6.05801 11.4954 6.12803 11.7228C6.46205 13.0547 7.6653 15.7428 12.0005 18C16.3357 15.7428 17.539 13.0547 17.872 11.7228C17.942 11.4954 17.9826 11.2607 17.993 11.0238Z"
      fill="white"
    />
  ]
};

export const StarInCircleFull = {
  viewBox: "0 0 24 24",
  body: () => [
    <circle key={1} cx="12" cy="12" r="12" fill="#CDD2D2" />,
    <path
      key={2}
      d="M12 15.1826L15.71 18L14.29 13.4504L18 10.6957H13.45L12 6L10.55 10.6957H6L9.71 13.4504L8.29 18L12 15.1826Z"
      fill="white"
    />
  ]
};

export const TickInCircleFull = {
  viewBox: "0 0 35 35",
  body: () => [
    <path
      key={1}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 17.5C0 7.83502 7.83502 0 17.5 0C27.165 0 35 7.83502 35 17.5C35 27.165 27.165 35 17.5 35C7.83502 35 0 27.165 0 17.5Z"
      fill="#32C864"
    />,
    <path
      key={2}
      d="M10 18.019L14.8349 22L25 11"
      fill="#32C864"
      stroke="white"
      strokeWidth="3"
    />
  ]
};

export const RefreshInCircleFull = {
  viewBox: "0 0 35 35",
  body: () => [
    <path
      key={1}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 17.5C0 7.83502 7.83502 0 17.5 0C27.165 0 35 7.83502 35 17.5C35 27.165 27.165 35 17.5 35C7.83502 35 0 27.165 0 17.5Z"
      fill="#00D2C8"
    />,
    <path
      key={2}
      d="M24.2694 13.6608L24.1818 13.5748L24.0942 13.6608L20.276 17.4108L20.058 17.625H20.3636H23.1008C23.033 20.5995 20.55 23 17.5 23C16.5562 23 15.66 22.7705 14.886 22.3584L14.8051 22.3153L14.7397 22.3796L13.346 23.7483L13.2327 23.8596L13.3676 23.9436C14.5607 24.6867 15.9771 25.125 17.5 25.125C21.7435 25.125 25.1924 21.7821 25.2603 17.625H28H28.3057L28.0876 17.4108L24.2694 13.6608ZM14.6364 17.375H11.8992C11.967 14.4005 14.45 12 17.5 12C18.4438 12 19.34 12.2295 20.114 12.6416L20.1949 12.6847L20.2603 12.6204L21.654 11.2517L21.7673 11.1404L21.6324 11.0564C20.4393 10.3133 19.0229 9.875 17.5 9.875C13.2565 9.875 9.80756 13.2179 9.73966 17.375H7H6.69434L6.91241 17.5892L10.7306 21.3392L10.8182 21.4252L10.9058 21.3392L14.724 17.5892L14.942 17.375H14.6364Z"
      fill="white"
      stroke="white"
      strokeWidth="0.25"
    />
  ]
};

export const XInCircleEmpty = {
  viewBox: "0 0 37 37",
  body: () => [
    <path
      key={1}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 18.5C1 8.83502 8.83502 1 18.5 1C28.165 1 36 8.83502 36 18.5C36 28.165 28.165 36 18.5 36C8.83502 36 1 28.165 1 18.5Z"
      fill="white"
      stroke="#D8D8D8"
    />,
    <path
      key={2}
      d="M23.167 25L25 23.167L20.333 18.5L25 13.833L23.167 12L18.5 16.667L13.833 12L12 13.833L16.667 18.5L12 23.167L13.833 25L18.5 20.333L23.167 25Z"
      fill="#787878"
    />
  ]
};

export const ArrowRight = {
  viewBox: "0 0 17 38",
  body: () => (
    <path
      fill="none"
      fillRule="evenodd"
      stroke="#A2646F"
      strokeWidth="3"
      d="M2 1l13 17.701L2 36.402"
    />
  )
};

export const ArrowLeft = {
  viewBox: "0 0 17 38",
  body: () => (
    <path
      fill="none"
      fillRule="evenodd"
      stroke="#A2646F"
      strokeWidth="3"
      d="M15 36.402l-13-17.7L15 1"
    />
  )
};

export const PlayCircle = {
  viewBox: "0 0 61 61",
  body: () => (
    <path
      d="M30.5 0.916748C14.17 0.916748 0.916626 14.1701 0.916626 30.5001C0.916626 46.8301 14.17 60.0834 30.5 60.0834C46.83 60.0834 60.0833 46.8301 60.0833 30.5001C60.0833 14.1701 46.83 0.916748 30.5 0.916748ZM24.5833 43.8126V17.1876L42.3333 30.5001L24.5833 43.8126Z"
      fill="white"
    />
  )
};

export const House = {
  viewBox: "0 0 20 22",
  body: () => [
    <path
      key={1}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 8L10 1L19 8V19C19 20.1046 18.1046 21 17 21H3C1.89543 21 1 20.1046 1 19V8Z"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key={2}
      d="M7 21V11H13V21"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ]
};

export const BarChartThin = {
  viewBox: "0 0 24 24",
  body: () => [
    <path
      key={1}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 3H22V21H18V3Z"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key={2}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 8H14V21H10V8Z"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key={3}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 13H6V21H2V13Z"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ]
};

export const Inbox = {
  viewBox: "0 0 24 24",
  body: () => [
    <path
      key={1}
      d="M22 13H16L14 16H10L8 13H2"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key={2}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.47 5.19L2 13V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V13L18.53 5.19C18.2093 4.46607 17.4918 3.99946 16.7 4H7.3C6.50822 3.99946 5.79067 4.46607 5.47 5.19Z"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ]
};

export const Integration = {
  viewBox: "0 0 24 24",
  body: () => [
    <path
      key={1}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1618 0.758789L14.7809 2.27092C14.7042 3.05193 15.2093 3.93524 16.1045 4.45205C16.9996 4.96886 18.0171 4.96464 18.6552 4.50773L21.3768 6.07904C21.855 6.35518 22.0189 6.96678 21.7428 7.44507L12.9534 22.6688C12.6772 23.1471 12.0656 23.311 11.5873 23.0348L8.86304 21.4619C8.93573 20.6828 8.43101 19.8035 7.53875 19.2884C6.64649 18.7732 5.63265 18.7758 4.99423 19.2283L2.37238 17.7146C1.89409 17.4384 1.73021 16.8268 2.00636 16.3485L10.7958 1.12481C11.0719 0.646521 11.6835 0.482647 12.1618 0.758789Z"
      fill="none"
    />,
    <line
      key={3}
      x1="8.25909"
      y1="4.69394"
      x2="19.2061"
      y2="11.0142"
      stroke="#333333"
    />
  ]
};

export const GraphArrow = {
  viewBox: "0 0 24 24",
  body: () => [
    <path
      key={1}
      d="M23 6L13.5 15.5L8.5 10.5L1 18"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key={2}
      d="M17 6H23V12"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ]
};

export const Suitcase = {
  viewBox: "0 0 24 24",
  body: () => [
    <path
      key={1}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 9C2 7.89543 2.89543 7 4 7H20C21.1046 7 22 7.89543 22 9V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V9Z"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key={2}
      d="M16 21V5C16 3.89543 15.1046 3 14 3H10C8.89543 3 8 3.89543 8 5V21"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ]
};

export const CalendarThin = {
  viewBox: "0 0 24 24",
  body: () => [
    <path
      key={1}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V6Z"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key={2}
      d="M16 2V6"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key={3}
      d="M8 2V6"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key={4}
      d="M3 10H21"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ]
};

export const LifeTyre = {
  viewBox: "0 0 24 24",
  body: () => [
    <path
      key={1}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key={2}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key={3}
      d="M4.92999 4.92969L9.16999 9.16969"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key={4}
      d="M14.83 14.8301L19.07 19.0701"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key={5}
      d="M14.83 9.16969L19.07 4.92969"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key={6}
      d="M14.83 9.16965L18.36 5.63965"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key={7}
      d="M4.92999 19.0701L9.16999 14.8301"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ]
};

export const Cog = {
  viewBox: "0 0 24 24",
  body: () => [
    <path
      key={1}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key={2}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.4 15C19.1277 15.6171 19.2583 16.3378 19.73 16.82L19.79 16.88C20.1656 17.2551 20.3766 17.7642 20.3766 18.295C20.3766 18.8258 20.1656 19.3349 19.79 19.71C19.4149 20.0856 18.9058 20.2966 18.375 20.2966C17.8442 20.2966 17.3351 20.0856 16.96 19.71L16.9 19.65C16.4178 19.1783 15.6971 19.0477 15.08 19.32C14.4755 19.5791 14.0826 20.1724 14.08 20.83V21C14.08 22.1046 13.1846 23 12.08 23C10.9754 23 10.08 22.1046 10.08 21V20.91C10.0642 20.2327 9.63587 19.6339 9 19.4C8.38291 19.1277 7.66219 19.2583 7.18 19.73L7.12 19.79C6.74486 20.1656 6.23582 20.3766 5.705 20.3766C5.17418 20.3766 4.66514 20.1656 4.29 19.79C3.91445 19.4149 3.70343 18.9058 3.70343 18.375C3.70343 17.8442 3.91445 17.3351 4.29 16.96L4.35 16.9C4.82167 16.4178 4.95235 15.6971 4.68 15.08C4.42093 14.4755 3.82764 14.0826 3.17 14.08H3C1.89543 14.08 1 13.1846 1 12.08C1 10.9754 1.89543 10.08 3 10.08H3.09C3.76733 10.0642 4.36613 9.63587 4.6 9C4.87235 8.38291 4.74167 7.66219 4.27 7.18L4.21 7.12C3.83445 6.74486 3.62343 6.23582 3.62343 5.705C3.62343 5.17418 3.83445 4.66514 4.21 4.29C4.58514 3.91445 5.09418 3.70343 5.625 3.70343C6.15582 3.70343 6.66486 3.91445 7.04 4.29L7.1 4.35C7.58219 4.82167 8.30291 4.95235 8.92 4.68H9C9.60447 4.42093 9.99738 3.82764 10 3.17V3C10 1.89543 10.8954 1 12 1C13.1046 1 14 1.89543 14 3V3.09C14.0026 3.74764 14.3955 4.34093 15 4.6C15.6171 4.87235 16.3378 4.74167 16.82 4.27L16.88 4.21C17.2551 3.83445 17.7642 3.62343 18.295 3.62343C18.8258 3.62343 19.3349 3.83445 19.71 4.21C20.0856 4.58514 20.2966 5.09418 20.2966 5.625C20.2966 6.15582 20.0856 6.66486 19.71 7.04L19.65 7.1C19.1783 7.58219 19.0477 8.30291 19.32 8.92V9C19.5791 9.60447 20.1724 9.99738 20.83 10H21C22.1046 10 23 10.8954 23 12C23 13.1046 22.1046 14 21 14H20.91C20.2524 14.0026 19.6591 14.3955 19.4 15Z"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ]
};

export const Pen = {
  viewBox: "0 0 20 22",
  body: () => [
    <path
      key={1}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1L16 5L5 16H1V12L12 1V1Z"
      stroke="#333333"
      strokeOpacity="0.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key={2}
      d="M1 21H19"
      stroke="#333333"
      strokeOpacity="0.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ]
};

export const BlankUser = {
  viewBox: "0 0 40 40",
  body: () => [
    <path
      key={1}
      d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
      fill="#FAFABE"
    />,
    <path
      key={2}
      d="M23.8255 27.0272V26.0653C25.4586 24.7901 26.7785 22.7096 27.1365 20.9199V20.8975C27.1588 20.8975 27.1812 20.8975 27.1812 20.8975C27.7405 20.9199 28.255 20.7856 28.7025 20.5172C29.1946 20.2263 29.5526 19.7789 29.6868 19.2644C29.821 18.7946 29.7315 18.3248 29.4407 18.0339C29.217 17.8102 28.9038 17.6984 28.5011 17.676C28.2327 17.6536 27.9418 17.676 27.651 17.7655C27.651 17.6089 27.651 17.4747 27.651 17.3628C27.651 17.3181 27.651 17.2733 27.651 17.2062C27.8076 16.3561 27.9866 15.4836 28.2327 14.8125C28.9038 13.0675 27.7629 12.7543 26.9799 12.978C26.2192 13.2017 25.8389 13.0451 25.8389 13.0451C25.8389 13.0451 26.5996 12.5977 26.4877 11.9937C26.3311 11.0764 25.1454 11.1659 23.9821 11.4791C23.3557 11.6357 23.0425 11.9266 22.9083 12.1503C23.0425 11.8147 23.2215 11.3225 23.1991 11.0317C23.1544 10.2711 22.5951 8.97354 20.0224 8.7722C16.9351 8.52611 14.877 10.3606 15.4586 12.5753C14.2058 12.5082 13.2438 12.5753 13.3557 14.0295C13.4228 15.0362 13.4228 17.1167 13.6689 18.3248C13.6913 18.459 13.7136 18.5709 13.736 18.7051C13.5794 18.7051 13.4228 18.7051 13.2662 18.7275C12.9754 18.7722 12.6398 18.8169 12.349 19.063C12.0134 19.3762 11.8568 19.8684 11.9687 20.3606C12.0134 20.5843 12.1253 20.8975 12.4608 21.1659C13.0649 21.7029 13.8926 21.591 14.2953 21.4791C15.0112 23.3807 16.1298 24.9467 17.4497 25.9758V26.8706C11.745 28.5932 10.0224 35.1033 10 35.1928L10.4698 35.3047C10.4922 35.2375 12.1029 29.0854 17.4497 27.3852V28.6827C17.4497 30.4501 18.8814 31.8818 20.6488 31.8818C22.4161 31.8818 23.8479 30.4501 23.8479 28.6827V27.5194C29.4407 29.3986 29.5302 35.3718 29.5302 35.6626H30C29.9776 35.5955 29.8881 28.9736 23.8255 27.0272ZM14.6532 21.1436C14.6309 21.0765 14.5861 21.0317 14.5414 21.0093C14.519 20.987 14.4743 20.987 14.4295 20.987C14.4072 20.987 14.3848 20.987 14.34 21.0093C14.2953 21.0317 13.3557 21.3673 12.7517 20.8527C12.5727 20.6961 12.4609 20.5172 12.4161 20.2935C12.349 20.025 12.4161 19.6671 12.6622 19.4433C12.8412 19.2867 13.0649 19.2644 13.311 19.2196C13.5347 19.1973 13.7584 19.1973 13.9821 19.242C14.0045 19.242 14.0268 19.242 14.0492 19.242C14.0716 19.2644 14.1163 19.2644 14.1387 19.2644C14.7204 19.3091 14.4743 16.6022 14.7427 15.8863C15.0336 15.1704 16.1745 14.9243 16.1745 14.9243C16.1745 14.9243 17.047 16.2219 19.2394 15.9982C21.4541 15.7744 22.1253 14.7006 22.1253 14.7006C22.1253 14.7006 22.7069 15.8416 23.8479 16.1548C24.9888 16.468 26.7338 15.4612 26.7338 15.4612C26.7338 15.4612 26.1521 19.8237 26.7338 19.8684C27.0246 19.8908 27.2036 19.1973 27.3826 18.28C27.4049 18.28 27.4273 18.28 27.4273 18.2577C27.7405 18.1458 28.0761 18.0787 28.4116 18.1011C28.7025 18.1234 28.9038 18.1905 29.038 18.3248C29.2394 18.5261 29.2394 18.8617 29.1723 19.1078C29.0604 19.4881 28.7919 19.846 28.4116 20.0697C28.0537 20.2711 27.6286 20.3829 27.1588 20.3829C27.0917 20.3829 27.0022 20.3829 26.9351 20.3606C26.8233 20.3382 26.689 20.4277 26.6667 20.5619L26.6219 20.7856C26.0626 24.0295 22.953 26.7812 20.8277 26.8035C18.3669 26.8259 15.8166 24.4993 14.6532 21.1436ZM20.6488 31.4344C19.1499 31.4344 17.9195 30.204 17.9195 28.7051V26.3561C18.8367 26.9601 19.821 27.2957 20.8054 27.2957H20.8277C21.6779 27.2957 22.528 26.9601 23.3557 26.4232V28.7275C23.3557 30.204 22.1477 31.4344 20.6488 31.4344Z"
      fill="#28283C"
    />
  ]
};

export const Flag = {
  viewBox: "0 0 34 39",
  body: () => (
    <path
      d="M20.8 5.25001L19.9167 0.833344H0.0416565V38.375H4.45832V22.9167H16.825L17.7083 27.3333H33.1667V5.25001H20.8Z"
      fill="#32C864"
    />
  )
};

export const StarSquare = {
  viewBox: "0 0 44 44",
  body: () => (
    <path
      d="M38.965 17.1667V38.9167H5.08334V5.08333H26.8333V0.25H5.13167C2.47334 0.25 0.29834 2.425 0.29834 5.08333V38.9167C0.29834 41.575 2.47334 43.75 5.13167 43.75H38.965C41.6233 43.75 43.7983 41.575 43.7983 38.9167V17.1667H38.965ZM34.0833 17.1667L36.355 12.1883L41.3333 9.91667L36.355 7.645L34.0833 2.66667L31.8117 7.645L26.8333 9.91667L31.8117 12.1883L34.0833 17.1667ZM25.0208 18.9792L22 12.3333L18.9792 18.9792L12.3333 22L18.9792 25.0208L22 31.6667L25.0208 25.0208L31.6667 22L25.0208 18.9792Z"
      fill="#822D50"
    />
  )
};

export const People = {
  viewBox: "0 0 58 38",
  body: () => (
    <path
      d="M39.3334 16.4167C43.6217 16.4167 47.0575 12.9551 47.0575 8.66672C47.0575 4.37838 43.6217 0.916718 39.3334 0.916718C35.045 0.916718 31.5834 4.37838 31.5834 8.66672C31.5834 12.9551 35.045 16.4167 39.3334 16.4167ZM18.6667 16.4167C22.955 16.4167 26.3909 12.9551 26.3909 8.66672C26.3909 4.37838 22.955 0.916718 18.6667 0.916718C14.3784 0.916718 10.9167 4.37838 10.9167 8.66672C10.9167 12.9551 14.3784 16.4167 18.6667 16.4167ZM18.6667 21.5834C12.6475 21.5834 0.583366 24.6059 0.583366 30.6251V37.0834H36.75V30.6251C36.75 24.6059 24.6859 21.5834 18.6667 21.5834ZM39.3334 21.5834C38.5842 21.5834 37.7317 21.6351 36.8275 21.7126C39.8242 23.8826 41.9167 26.8017 41.9167 30.6251V37.0834H57.4167V30.6251C57.4167 24.6059 45.3525 21.5834 39.3334 21.5834Z"
      fill="#FBB231"
    />
  )
};

export const MoneySquare = {
  viewBox: "0 0 50 48",
  body: () => (
    <path
      d="M47.25 39.5V42.0833C47.25 44.925 44.925 47.25 42.0833 47.25H5.91667C3.04917 47.25 0.75 44.925 0.75 42.0833V5.91667C0.75 3.075 3.04917 0.75 5.91667 0.75H42.0833C44.925 0.75 47.25 3.075 47.25 5.91667V8.5H24C21.1325 8.5 18.8333 10.825 18.8333 13.6667V34.3333C18.8333 37.175 21.1325 39.5 24 39.5H47.25ZM24 34.3333H49.8333V13.6667H24V34.3333ZM34.3333 27.875C32.1892 27.875 30.4583 26.1442 30.4583 24C30.4583 21.8558 32.1892 20.125 34.3333 20.125C36.4775 20.125 38.2083 21.8558 38.2083 24C38.2083 26.1442 36.4775 27.875 34.3333 27.875Z"
      fill="#00D2C8"
    />
  )
};

export const Page = {
  viewBox: "0 0 24 24",
  body: () => [
    <path
      key={1}
      d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
      stroke="#333333"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      key={2}
      d="M14 2V8H20"
      stroke="#333333"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      key={3}
      d="M16 13H8"
      stroke="#333333"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      key={4}
      d="M16 17H8"
      stroke="#333333"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      key={5}
      d="M10 9H9H8"
      stroke="#333333"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ]
};

export const PeopleThin = {
  viewBox: "0 0 22 22",
  body: () => [
    <path
      key={1}
      d="M15.5834 19.25V17.4167C15.5834 16.4442 15.1971 15.5116 14.5095 14.8239C13.8218 14.1363 12.8892 13.75 11.9167 13.75H4.58341C3.61095 13.75 2.67832 14.1363 1.99069 14.8239C1.30306 15.5116 0.916748 16.4442 0.916748 17.4167V19.25"
      stroke="#333333"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round
    "
    />,
    <path
      key={2}
      d="M8.24992 10.0833C10.275 10.0833 11.9166 8.44171 11.9166 6.41667C11.9166 4.39162 10.275 2.75 8.24992 2.75C6.22487 2.75 4.58325 4.39162 4.58325 6.41667C4.58325 8.44171 6.22487 10.0833 8.24992 10.0833Z"
      stroke="#333333"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      key={3}
      d="M21.0833 19.25V17.4166C21.0826 16.6042 20.8122 15.815 20.3145 15.1729C19.8168 14.5308 19.1199 14.0722 18.3333 13.8691"
      stroke="#333333"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      key={4}
      d="M14.6667 2.86914C15.4555 3.07108 16.1545 3.52978 16.6537 4.17293C17.153 4.81607 17.4239 5.60707 17.4239 6.42122C17.4239 7.23538 17.153 8.02638 16.6537 8.66952C16.1545 9.31266 15.4555 9.77136 14.6667 9.97331"
      stroke="#333333"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ]
};

export const Briefcase = {
  viewBox: "0 0 24 24",
  body: () => [
    <rect
      key={1}
      x="2"
      y="7"
      width="20"
      height="14"
      rx="2"
      ry="2"
      stroke="#ffffff"
      fill="none"
    />,
    <path
      key={2}
      d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"
      stroke="#ffffff"
      fill="none"
    />
  ]
};

export const Buffer = {
  viewBox: "0 0 46 49",
  body: () => (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41.425 27.5001L22.975 41.8501L4.55 27.5251L0.5 30.6751L23 48.1751L45.5 30.6751L41.425 27.5001ZM23 0.5L0.5 18L4.575 21.175L23 35.5L41.4 21.175L45.5 18L23 0.5ZM23 29.175L8.65001 18L23 6.82504L37.35 18L23 29.175Z"
    />
  )
};

export const ThinTick = {
  viewBox: "0 0 18 14",
  body: () => (
    <path
      stroke="none"
      fill="#8298AB"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.80934 11.3968L16.7878 0.5L17.8499 1.55405L5.81425 13.5L5.76569 13.4518L0.149902 7.88009L1.21198 6.82604L5.80934 11.3968Z"
    />
  )
};

export const Contrast = {
  viewBox: "0 0 50 50",
  body: () => (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25 0C11.2 0 0 11.2 0 25C0 38.8 11.2 50 25 50C38.8 50 50 38.8 50 25C50 11.2 38.8 0 25 0ZM22.5 44.825C12.65 43.6 5 35.2 5 25C5 14.8 12.625 6.4 22.5 5.175V44.825ZM27.5 5.175C30.075 5.5 32.5 6.3 34.675 7.5H27.5V5.175ZM27.5 12.5H40.6C41.225 13.275 41.8 14.125 42.3 15H27.5V12.5ZM27.5 20H44.35C44.55 20.825 44.725 21.65 44.825 22.5H27.5V20ZM27.5 44.825V42.5H34.675C32.5 43.7 30.075 44.5 27.5 44.825ZM40.6 37.5H27.5V35H42.3C41.8 35.875 41.225 36.725 40.6 37.5ZM44.35 30H27.5V27.5H44.825C44.725 28.35 44.55 29.175 44.35 30Z"
    />
  )
};

export const Thumbnail = {
  viewBox: "0 0 50 40",
  body: () => (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45 0H5C2.25 0 0 2.25 0 5V35C0 37.75 2.25 40 5 40H45C47.75 40 50 37.75 50 35V5C50 2.25 47.75 0 45 0ZM45 35H5V5H45V35ZM22.5 20H42.5V32.5H22.5V20Z"
    />
  )
};

export const CubeCorners = {
  viewBox: "0 0 50 50",
  body: () => [
    <path
      key={1}
      d="M40 15C42.75 15 45 12.75 45 10C45 7.25 42.75 5 40 5C37.25 5 35 7.25 35 10C35 12.75 37.25 15 40 15Z"
    />,
    <path
      key={2}
      d="M40 35C42.75 35 45 32.75 45 30C45 27.25 42.75 25 40 25C37.25 25 35 27.25 35 30C35 32.75 37.25 35 40 35Z"
    />,
    <path
      key={3}
      d="M10 15C7.25 15 5 17.25 5 20C5 22.75 7.25 25 10 25C12.75 25 15 22.75 15 20C15 17.25 12.75 15 10 15Z"
    />,
    <path
      key={4}
      d="M20 5C17.25 5 15 7.25 15 10C15 12.75 17.25 15 20 15C22.75 15 25 12.75 25 10C25 7.25 22.75 5 20 5Z"
    />,
    <path
      key={5}
      d="M30 35C27.25 35 25 37.25 25 40C25 42.75 27.25 45 30 45C32.75 45 35 42.75 35 40C35 37.25 32.75 35 30 35Z"
    />,
    <path
      key={6}
      d="M10 45C12.75 45 15 42.75 15 40C15 37.25 12.75 35 10 35C7.25 35 5 37.25 5 40C5 42.75 7.25 45 10 45Z"
    />,
    <path
      key={7}
      d="M30 15C27.25 15 25 17.25 25 20C25 22.75 27.25 25 30 25C32.75 25 35 22.75 35 20C35 17.25 32.75 15 30 15Z"
    />,
    <path
      key={8}
      d="M25 30C25 32.75 22.75 35 20 35C17.25 35 15 32.75 15 30C15 27.25 17.25 25 20 25C22.75 25 25 27.25 25 30Z"
    />
  ]
};

export const FlatArrow = {
  viewBox: "0 0 9 5",
  body: () => <path d="M4.5 5L0.602886 0.5L8.39711 0.5L4.5 5Z" fill="#81868A" />
};

export const ChevronThick = {
  viewBox: "0 0 9 14",
  body: () => (
    <path
      d="M1.83329 0.5L0.305786 2.0275L5.26746 7L0.305786 11.9725L1.83329 13.5L8.33329 7L1.83329 0.5Z"
      fill="black"
    />
  )
};

export const BoldEnvelope = {
  viewBox: "0 0 24 24",
  body: () => (
    <path
      d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"
      fill="#28283C"
    />
  )
};

export const BoldClock = {
  viewBox: "0 0 24 24",
  body: () => [
    <path
      key={1}
      d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
      fill="#28283C"
    />,
    <path
      key={2}
      d="M12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z"
      fill="#28283C"
    />
  ]
};

export const BoldXCircle = {
  viewBox: "0 0 24 24",
  body: () => [
    <path
      key={1}
      d="M11 20.1667C16.0626 20.1667 20.1667 16.0627 20.1667 11C20.1667 5.93743 16.0626 1.83337 11 1.83337C5.93738 1.83337 1.83333 5.93743 1.83333 11C1.83333 16.0627 5.93738 20.1667 11 20.1667Z"
      stroke="#28283C"
      strokeWidth="2"
      fill="transparent"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      key={2}
      d="M13.75 8.25L8.25 13.75"
      stroke="#28283C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      key={3}
      d="M8.25 8.25L13.75 13.75"
      stroke="#28283C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ]
};

export const BoldCircleTick = {
  viewBox: "0 0 34 34",
  body: () => [
    <circle
      key={1}
      cx="17"
      cy="17"
      r="15.5"
      transform="rotate(90 17 17)"
      fill="white"
      stroke="#00D2C8"
      strokeWidth="3"
    />,
    <path
      key={2}
      d="M10 17.7576L14.4681 22L25 12"
      stroke="#00D2C8"
      strokeWidth="4"
      fill="transparent"
    />
  ]
};

export const BoldEmailCircle = {
  viewBox: "0 0 34 34",
  body: () => [
    <circle
      key={1}
      cx="17"
      cy="17"
      r="15.5"
      transform="rotate(90 17 17)"
      fill="white"
      stroke="#00D2C8"
      strokeWidth="3"
    />,
    <path
      key={2}
      d="M10.7727 24.125H23.7727C24.276 24.125 24.7587 23.9251 25.1146 23.5692C25.4705 23.2133 25.6705 22.7306 25.6705 22.2273V12.7727C25.6705 12.2694 25.4705 11.7867 25.1146 11.4308C24.7587 11.0749 24.276 10.875 23.7727 10.875H10.7727C10.2694 10.875 9.78672 11.0749 9.43083 11.4308C9.07494 11.7867 8.875 12.2694 8.875 12.7727V22.2273C8.875 22.7306 9.07494 23.2133 9.43083 23.5692C9.78672 23.9251 10.2694 24.125 10.7727 24.125ZM10.4433 12.4433C10.5307 12.3559 10.6492 12.3068 10.7727 12.3068H23.7727C23.8963 12.3068 24.0148 12.3559 24.1022 12.4433C24.1895 12.5307 24.2386 12.6492 24.2386 12.7727V22.2273C24.2386 22.3508 24.1895 22.4693 24.1022 22.5567C24.0148 22.6441 23.8963 22.6932 23.7727 22.6932H10.7727C10.6492 22.6932 10.5307 22.6441 10.4433 22.5567C10.3559 22.4693 10.3068 22.3508 10.3068 22.2273V12.7727C10.3068 12.6492 10.3559 12.5307 10.4433 12.4433Z"
      fill="#00D2C8"
      stroke="#00D2C8"
      strokeWidth="0.25"
    />,
    <path
      key={3}
      d="M25.0724 12.283L24.9486 12.2653L25.0724 12.283C25.0857 12.1899 25.0805 12.0951 25.0572 12.0041C25.0339 11.913 24.9928 11.8274 24.9364 11.7522L24.8364 11.8272L24.9364 11.7522C24.88 11.677 24.8093 11.6136 24.7284 11.5657C24.6475 11.5178 24.558 11.4863 24.4649 11.473C24.3718 11.4597 24.2771 11.4649 24.186 11.4882C24.0949 11.5116 24.0093 11.5526 23.9341 11.609L17.2728 16.605L10.6114 11.609C10.4595 11.4951 10.2686 11.4462 10.0806 11.473C9.89265 11.4999 9.72305 11.6003 9.60913 11.7522C9.4952 11.9041 9.44629 12.095 9.47314 12.283C9.48644 12.376 9.51793 12.4656 9.56583 12.5465C9.61373 12.6274 9.6771 12.6981 9.75231 12.7545L16.8432 18.0726C16.9671 18.1656 17.1179 18.2158 17.2728 18.2158C17.4277 18.2158 17.5784 18.1656 17.7023 18.0726L24.7932 12.7545C24.8684 12.698 24.9318 12.6274 24.9797 12.5465C25.0276 12.4656 25.0591 12.376 25.0724 12.283Z"
      fill="#00D2C8"
      stroke="#00D2C8"
      strokeWidth="0.25"
    />
  ]
};

export const BoldCalendarCircle = {
  viewBox: "0 0 34 34",
  body: () => [
    <circle
      key={1}
      cx="17"
      cy="17"
      r="15.5"
      transform="rotate(90 17 17)"
      fill="white"
      stroke="#00D2C8"
      strokeWidth="3"
    />,
    <path
      key={2}
      d="M23.3307 25H10.6693C9.74933 25 9 24.2513 9 23.3307V12.0033C9 11.0827 9.74933 10.3333 10.67 10.3333H23.33C24.2507 10.3333 25 11.0827 25 12.0033V23.3307C25 24.2513 24.2513 25 23.3307 25ZM10.67 11.6667C10.4847 11.6667 10.3333 11.818 10.3333 12.0033V23.3307C10.3333 23.516 10.484 23.6667 10.6693 23.6667H23.3307C23.516 23.6667 23.6667 23.516 23.6667 23.3307V12.0033C23.6667 11.818 23.5153 11.6667 23.33 11.6667H10.67ZM24.3333 14.3333H9.66667C9.29867 14.3333 9 14.0347 9 13.6667C9 13.2987 9.29867 13 9.66667 13H24.3333C24.702 13 25 13.2987 25 13.6667C25 14.0347 24.702 14.3333 24.3333 14.3333ZM12.3333 12.3333C11.9653 12.3333 11.6667 12.0347 11.6667 11.6667V9.66667C11.6667 9.29867 11.9653 9 12.3333 9C12.7013 9 13 9.29867 13 9.66667V11.6667C13 12.0347 12.7013 12.3333 12.3333 12.3333ZM21.6667 12.3333C21.298 12.3333 21 12.0347 21 11.6667V9.66667C21 9.29867 21.298 9 21.6667 9C22.0353 9 22.3333 9.29867 22.3333 9.66667V11.6667C22.3333 12.0347 22.0353 12.3333 21.6667 12.3333Z"
      fill="#00D2C8"
    />,
    <path
      key={3}
      d="M13 22.3333C13.3682 22.3333 13.6667 22.0349 13.6667 21.6667C13.6667 21.2985 13.3682 21 13 21C12.6319 21 12.3334 21.2985 12.3334 21.6667C12.3334 22.0349 12.6319 22.3333 13 22.3333Z"
      fill="#00D2C8"
    />,
    <path
      key={4}
      d="M13 19.6666C13.3682 19.6666 13.6667 19.3681 13.6667 18.9999C13.6667 18.6317 13.3682 18.3333 13 18.3333C12.6319 18.3333 12.3334 18.6317 12.3334 18.9999C12.3334 19.3681 12.6319 19.6666 13 19.6666Z"
      fill="#00D2C8"
    />,
    <path
      key={5}
      d="M15 22.3333C15.3682 22.3333 15.6667 22.0349 15.6667 21.6667C15.6667 21.2985 15.3682 21 15 21C14.6319 21 14.3334 21.2985 14.3334 21.6667C14.3334 22.0349 14.6319 22.3333 15 22.3333Z"
      fill="#00D2C8"
    />,
    <path
      key={6}
      d="M15 19.6666C15.3682 19.6666 15.6667 19.3681 15.6667 18.9999C15.6667 18.6317 15.3682 18.3333 15 18.3333C14.6319 18.3333 14.3334 18.6317 14.3334 18.9999C14.3334 19.3681 14.6319 19.6666 15 19.6666Z"
      fill="#00D2C8"
    />,
    <path
      key={7}
      d="M15 17.0001C15.3682 17.0001 15.6667 16.7016 15.6667 16.3334C15.6667 15.9652 15.3682 15.6667 15 15.6667C14.6319 15.6667 14.3334 15.9652 14.3334 16.3334C14.3334 16.7016 14.6319 17.0001 15 17.0001Z"
      fill="#00D2C8"
    />,
    <path
      key={8}
      d="M19 22.3333C19.3682 22.3333 19.6667 22.0349 19.6667 21.6667C19.6667 21.2985 19.3682 21 19 21C18.6319 21 18.3334 21.2985 18.3334 21.6667C18.3334 22.0349 18.6319 22.3333 19 22.3333Z"
      fill="#00D2C8"
    />,
    <path
      key={9}
      d="M19 19.6666C19.3682 19.6666 19.6667 19.3681 19.6667 18.9999C19.6667 18.6317 19.3682 18.3333 19 18.3333C18.6319 18.3333 18.3334 18.6317 18.3334 18.9999C18.3334 19.3681 18.6319 19.6666 19 19.6666Z"
      fill="#00D2C8"
    />,
    <path
      key={10}
      d="M19 17.0001C19.3682 17.0001 19.6667 16.7016 19.6667 16.3334C19.6667 15.9652 19.3682 15.6667 19 15.6667C18.6319 15.6667 18.3334 15.9652 18.3334 16.3334C18.3334 16.7016 18.6319 17.0001 19 17.0001Z"
      fill="#00D2C8"
    />,
    <path
      key={11}
      d="M21 19.6666C21.3682 19.6666 21.6667 19.3681 21.6667 18.9999C21.6667 18.6317 21.3682 18.3333 21 18.3333C20.6319 18.3333 20.3334 18.6317 20.3334 18.9999C20.3334 19.3681 20.6319 19.6666 21 19.6666Z"
      fill="#00D2C8"
    />,
    <path
      key={12}
      d="M21 17.0001C21.3682 17.0001 21.6667 16.7016 21.6667 16.3334C21.6667 15.9652 21.3682 15.6667 21 15.6667C20.6319 15.6667 20.3334 15.9652 20.3334 16.3334C20.3334 16.7016 20.6319 17.0001 21 17.0001Z"
      fill="#00D2C8"
    />,
    <path
      key={13}
      d="M17 22.3333C17.3682 22.3333 17.6667 22.0349 17.6667 21.6667C17.6667 21.2985 17.3682 21 17 21C16.6319 21 16.3334 21.2985 16.3334 21.6667C16.3334 22.0349 16.6319 22.3333 17 22.3333Z"
      fill="#00D2C8"
    />,
    <path
      key={14}
      d="M17 19.6666C17.3682 19.6666 17.6667 19.3681 17.6667 18.9999C17.6667 18.6317 17.3682 18.3333 17 18.3333C16.6319 18.3333 16.3334 18.6317 16.3334 18.9999C16.3334 19.3681 16.6319 19.6666 17 19.6666Z"
      fill="#00D2C8"
    />,
    <path
      key={15}
      d="M17 17.0001C17.3682 17.0001 17.6667 16.7016 17.6667 16.3334C17.6667 15.9652 17.3682 15.6667 17 15.6667C16.6319 15.6667 16.3334 15.9652 16.3334 16.3334C16.3334 16.7016 16.6319 17.0001 17 17.0001Z"
      fill="#00D2C8"
    />
  ]
};

export const BoldStarCircle = {
  viewBox: "0 0 40 40",
  body: () => [
    <circle
      key={1}
      cx="20"
      cy="20"
      r="18.5"
      transform="rotate(90 20 20)"
      fill="white"
      stroke="#00D2C8"
      strokeWidth="3"
    />,
    <path
      key={2}
      d="M19.0489 13.927C19.3483 13.0057 20.6517 13.0057 20.9511 13.9271L22.0206 17.2188C22.1545 17.6309 22.5385 17.9098 22.9717 17.9098H26.4329C27.4016 17.9098 27.8044 19.1494 27.0207 19.7188L24.2205 21.7533C23.87 22.0079 23.7234 22.4593 23.8572 22.8713L24.9268 26.1631C25.2261 27.0844 24.1717 27.8506 23.388 27.2812L20.5878 25.2467C20.2373 24.9921 19.7627 24.9921 19.4122 25.2467L16.612 27.2812C15.8283 27.8506 14.7739 27.0844 15.0732 26.1631L16.1428 22.8713C16.2766 22.4593 16.13 22.0079 15.7795 21.7533L12.9793 19.7188C12.1956 19.1494 12.5984 17.9098 13.5671 17.9098H17.0283C17.4615 17.9098 17.8455 17.6309 17.9794 17.2188L19.0489 13.927Z"
      fill="#00D2C8"
    />
  ]
};

export const PointyArrow = {
  viewBox: "0 0 76 75",
  body: () => (
    <path
      d="M6.4945 18.0458C6.68954 17.5291 7.26652 17.2684 7.78322 17.4634L16.2033 20.6418C16.72 20.8368 16.9808 21.4138 16.7857 21.9305C16.5907 22.4472 16.0137 22.7079 15.497 22.5129L8.01248 19.6877L5.18727 27.1722C4.99223 27.6889 4.41525 27.9497 3.89855 27.7546C3.38185 27.5596 3.1211 26.9826 3.31614 26.4659L6.4945 18.0458ZM72.8393 46.9776C73.3373 47.2164 73.5475 47.8137 73.3087 48.3117L69.4179 56.4272C69.1792 56.9252 68.5819 57.1354 68.0839 56.8966C67.5859 56.6579 67.3757 56.0606 67.6145 55.5626L71.073 48.3488L63.8592 44.8903C63.3612 44.6515 63.151 44.0543 63.3898 43.5563C63.6285 43.0582 64.2258 42.8481 64.7238 43.0868L72.8393 46.9776ZM8.34133 17.9871C11.6803 25.3753 18.8972 35.7163 29.642 42.6487C40.3449 49.5541 54.5676 53.0965 72.0751 46.9361L72.7389 48.8227C54.5932 55.2077 39.7291 51.5369 28.5577 44.3293C17.4282 37.1487 9.98331 26.4768 6.5188 18.8108L8.34133 17.9871Z"
      fill="white"
    />
  )
};

export const CalendarThick = {
  viewBox: "0 0 19 19",
  body: () => [
    <path
      key={1}
      d="M17.0177 19H1.98233C0.889833 19 0 18.111 0 17.0177V3.56646C0 2.47317 0.889833 1.58333 1.98313 1.58333H17.0169C18.1102 1.58333 19 2.47317 19 3.56646V17.0177C19 18.111 18.111 19 17.0177 19ZM1.98313 3.16667C1.76304 3.16667 1.58333 3.34638 1.58333 3.56646V17.0177C1.58333 17.2378 1.76225 17.4167 1.98233 17.4167H17.0177C17.2378 17.4167 17.4167 17.2378 17.4167 17.0177V3.56646C17.4167 3.34638 17.237 3.16667 17.0169 3.16667H1.98313ZM18.2083 6.33333H0.791667C0.354667 6.33333 0 5.97867 0 5.54167C0 5.10467 0.354667 4.75 0.791667 4.75H18.2083C18.6461 4.75 19 5.10467 19 5.54167C19 5.97867 18.6461 6.33333 18.2083 6.33333ZM3.95833 3.95833C3.52133 3.95833 3.16667 3.60367 3.16667 3.16667V0.791667C3.16667 0.354667 3.52133 0 3.95833 0C4.39533 0 4.75 0.354667 4.75 0.791667V3.16667C4.75 3.60367 4.39533 3.95833 3.95833 3.95833ZM15.0417 3.95833C14.6039 3.95833 14.25 3.60367 14.25 3.16667V0.791667C14.25 0.354667 14.6039 0 15.0417 0C15.4795 0 15.8333 0.354667 15.8333 0.791667V3.16667C15.8333 3.60367 15.4795 3.95833 15.0417 3.95833Z"
      fill="#28283C"
    />,
    <path
      key={2}
      d="M4.74967 15.8333C5.1869 15.8333 5.54134 15.4789 5.54134 15.0417C5.54134 14.6044 5.1869 14.25 4.74967 14.25C4.31245 14.25 3.95801 14.6044 3.95801 15.0417C3.95801 15.4789 4.31245 15.8333 4.74967 15.8333Z"
      fill="#28283C"
    />,
    <path
      key={3}
      d="M4.74967 12.6668C5.1869 12.6668 5.54134 12.3124 5.54134 11.8752C5.54134 11.4379 5.1869 11.0835 4.74967 11.0835C4.31245 11.0835 3.95801 11.4379 3.95801 11.8752C3.95801 12.3124 4.31245 12.6668 4.74967 12.6668Z"
      fill="#28283C"
    />,
    <path
      key={4}
      d="M7.12467 15.8333C7.5619 15.8333 7.91634 15.4789 7.91634 15.0417C7.91634 14.6044 7.5619 14.25 7.12467 14.25C6.68745 14.25 6.33301 14.6044 6.33301 15.0417C6.33301 15.4789 6.68745 15.8333 7.12467 15.8333Z"
      fill="#28283C"
    />,
    <path
      key={5}
      d="M7.12467 12.6668C7.5619 12.6668 7.91634 12.3124 7.91634 11.8752C7.91634 11.4379 7.5619 11.0835 7.12467 11.0835C6.68745 11.0835 6.33301 11.4379 6.33301 11.8752C6.33301 12.3124 6.68745 12.6668 7.12467 12.6668Z"
      fill="#28283C"
    />,
    <path
      key={6}
      d="M7.12467 9.49984C7.5619 9.49984 7.91634 9.1454 7.91634 8.70817C7.91634 8.27095 7.5619 7.9165 7.12467 7.9165C6.68745 7.9165 6.33301 8.27095 6.33301 8.70817C6.33301 9.1454 6.68745 9.49984 7.12467 9.49984Z"
      fill="#28283C"
    />,
    <path
      key={7}
      d="M11.8747 15.8333C12.3119 15.8333 12.6663 15.4789 12.6663 15.0417C12.6663 14.6044 12.3119 14.25 11.8747 14.25C11.4374 14.25 11.083 14.6044 11.083 15.0417C11.083 15.4789 11.4374 15.8333 11.8747 15.8333Z"
      fill="#28283C"
    />,
    <path
      key={8}
      d="M11.8747 12.6668C12.3119 12.6668 12.6663 12.3124 12.6663 11.8752C12.6663 11.4379 12.3119 11.0835 11.8747 11.0835C11.4374 11.0835 11.083 11.4379 11.083 11.8752C11.083 12.3124 11.4374 12.6668 11.8747 12.6668Z"
      fill="#28283C"
    />,
    <path
      key={9}
      d="M11.8747 9.49984C12.3119 9.49984 12.6663 9.1454 12.6663 8.70817C12.6663 8.27095 12.3119 7.9165 11.8747 7.9165C11.4374 7.9165 11.083 8.27095 11.083 8.70817C11.083 9.1454 11.4374 9.49984 11.8747 9.49984Z"
      fill="#28283C"
    />,
    <path
      key={10}
      d="M14.2497 12.6668C14.6869 12.6668 15.0413 12.3124 15.0413 11.8752C15.0413 11.4379 14.6869 11.0835 14.2497 11.0835C13.8124 11.0835 13.458 11.4379 13.458 11.8752C13.458 12.3124 13.8124 12.6668 14.2497 12.6668Z"
      fill="#28283C"
    />,
    <path
      key={11}
      d="M14.2497 9.49984C14.6869 9.49984 15.0413 9.1454 15.0413 8.70817C15.0413 8.27095 14.6869 7.9165 14.2497 7.9165C13.8124 7.9165 13.458 8.27095 13.458 8.70817C13.458 9.1454 13.8124 9.49984 14.2497 9.49984Z"
      fill="#28283C"
    />,
    <path
      key={12}
      d="M9.49967 15.8333C9.9369 15.8333 10.2913 15.4789 10.2913 15.0417C10.2913 14.6044 9.9369 14.25 9.49967 14.25C9.06245 14.25 8.70801 14.6044 8.70801 15.0417C8.70801 15.4789 9.06245 15.8333 9.49967 15.8333Z"
      fill="#28283C"
    />,
    <path
      key={13}
      d="M9.49967 12.6668C9.9369 12.6668 10.2913 12.3124 10.2913 11.8752C10.2913 11.4379 9.9369 11.0835 9.49967 11.0835C9.06245 11.0835 8.70801 11.4379 8.70801 11.8752C8.70801 12.3124 9.06245 12.6668 9.49967 12.6668Z"
      fill="#28283C"
    />,
    <path
      key={14}
      d="M9.49967 9.49984C9.9369 9.49984 10.2913 9.1454 10.2913 8.70817C10.2913 8.27095 9.9369 7.9165 9.49967 7.9165C9.06245 7.9165 8.70801 8.27095 8.70801 8.70817C8.70801 9.1454 9.06245 9.49984 9.49967 9.49984Z"
      fill="#28283C"
    />
  ]
};

export const TurnLeft = {
  viewBox: "0 0 86 87",
  body: () => (
    <path d="M1.66969 26.4048C1.56637 26.6093 1.64843 26.8589 1.85297 26.9622L5.18611 28.6457C5.39065 28.7491 5.64021 28.667 5.74353 28.4625C5.84684 28.2579 5.76478 28.0084 5.56024 27.905L2.59745 26.4085L4.09395 23.4458C4.19726 23.2412 4.1152 22.9917 3.91066 22.8883C3.70612 22.785 3.45656 22.8671 3.35325 23.0716L1.66969 26.4048ZM78.5583 59.6401C78.771 59.7254 79.0126 59.6222 79.0979 59.4096L80.4885 55.944C80.5739 55.7313 80.4707 55.4897 80.258 55.4044C80.0453 55.319 79.8037 55.4223 79.7184 55.6349L78.4823 58.7155L75.4018 57.4793C75.1891 57.394 74.9475 57.4972 74.8622 57.7099C74.7768 57.9226 74.8801 58.1641 75.0927 58.2495L78.5583 59.6401ZM2.16964 26.986C11.2747 23.9921 26.0238 22.0204 40.6407 25.8411C55.2375 29.6566 69.7136 39.2491 78.3313 59.4181L79.0944 59.092C70.3663 38.6649 55.6711 28.9122 40.8505 25.0383C26.0499 21.1695 11.1356 23.1643 1.91043 26.1977L2.16964 26.986Z" />
  )
};

export const CirclePlus = {
  viewBox: "0 0 28 28",
  body: () => [
    <path
      key={1}
      d="M14.1818 1.18175C7.10253 1.18175 1.36364 6.92065 1.36364 13.9999C1.36364 21.0792 7.10253 26.8181 14.1818 26.8181C21.2611 26.8181 27 21.0792 27 13.9999C27 6.92065 21.2611 1.18175 14.1818 1.18175Z"
      fill="white"
      stroke="#03C2B9"
      strokeWidth="2"
    />,
    <path
      key={2}
      d="M14.1816 8.48486V20.303"
      stroke="#03C2B9"
      strokeWidth="1.8"
    />,
    <path
      key={3}
      d="M7.87891 14L20.485 14"
      stroke="#03C2B9"
      strokeWidth="1.8"
    />
  ]
};

export const CircleMinus = {
  viewBox: "0 0 28 28",
  body: () => [
    <path
      key={1}
      d="M14.1818 1.18175C7.10253 1.18175 1.36364 6.92065 1.36364 13.9999C1.36364 21.0792 7.10253 26.8181 14.1818 26.8181C21.2611 26.8181 27 21.0792 27 13.9999C27 6.92065 21.2611 1.18175 14.1818 1.18175Z"
      fill="white"
      stroke="#03C2B9"
      strokeWidth="2"
    />,
    <path
      key={2}
      d="M7.87891 14L20.485 14"
      stroke="#03C2B9"
      strokeWidth="1.8"
    />
  ]
};
